const urlConfig = (function() {
  const host = window.location.host;
  if (host == "8.214.37.207:8054") {
    //新加坡环境
    return {
      REQUEST_URL: "//8.214.37.207:8010",
      WEBSOCKET_URL: "8.214.37.207:8058"
    };
  } else if (
    host.indexOf("hetu.5gomsg.com") > -1 ||
    host.indexOf("www.5gomsg.com") > -1 ||
    host.indexOf("bizapp.5gomsg.com") > -1 ||
    host.indexOf("localhost:8080") > -1
  ) {
    //河图阿里云环境
    return {
      REQUEST_URL: "//api.5gomsg.com",
      WEBSOCKET_URL: "//hetu.5gomsg.com"
    };
  } else if (host.indexOf("10.45.50.230:8321") > -1) {
    //开发环境
    return {
      EVN_CONFIG: '"dev"',
      REQUEST_URL: "//10.45.50.230:8007",
      WEBSOCKET_URL: "//10.45.50.59:8058"
    };
  } else {
    //其他环境
    return {
      checkVerifyCodeUrl: `//${window.location.host}`,
      REQUEST_URL: `//${window.location.host}`,
      WEBSOCKET_URL: `//${window.location.host}`
    };
  }
})();
export default urlConfig;



// WEBPACK FOOTER //
// ./src/apiConfig.js